import script from "./MapSDGs.vue?vue&type=script&setup=true&lang=js"
export * from "./MapSDGs.vue?vue&type=script&setup=true&lang=js"

import "./MapSDGs.vue?vue&type=style&index=0&id=7d9ba28a&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9ba28a"]])

export default __exports__